import { IApprovalDocumentMasterRegistrationType } from 'pages/ApprovalDocumentGroup/ApprovalDocumentMasterRegistration/type';
import { InitialApprovalDocMasterRegisSettingType } from '.';
import { Actions, types } from './actions';

const initialState: InitialApprovalDocMasterRegisSettingType = {
  approvalDocMasterDetails: undefined,
  extendedInfo: [],
  passOfApprovalList: { keyWork: '', page: 0, size: 10 },
};

const reducer = (state = initialState, action: Actions): InitialApprovalDocMasterRegisSettingType => {
  const newState = { ...state };
  switch (action.type) {
    case types.SAVE_APPROVAL_DM_RESGIS_SETTINGS:
      newState.approvalDocMasterDetails = action.payload;
      return newState;

    case types.SAVE_EXTENDED_INFO:
      newState.extendedInfo = action.payload;
      return newState;

    case types.SAVE_PASS_APPROVAL_LIST:
      newState.passOfApprovalList = action.payload;
      return newState;

    default:
      return state;
  }
};

export default reducer;
